export default "__VITE_ASSET__B7tZuWp0__"